import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const LastImplementedFiscalYearPeriodTag: FC = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });

  const lastImplementedFiscalYearPeriod = useWatch({
    control,
    name: 'lastImplementedFiscalYearPeriod',
  });

  if (sheetType !== 'RS' || !lastImplementedFiscalYearPeriod?.length) {
    return null;
  }
  const startYear = lastImplementedFiscalYearPeriod?.[0]?.year().toString();
  const endYear = lastImplementedFiscalYearPeriod?.[1]?.year().toString();

  return (
    <>
      {startYear && (
        <SearchFilterTag
          closable={true}
          label={t('last-implemented-fiscal-year-range-min-with-value', {
            value: startYear,
          })}
          onClose={() => {
            setValue('lastImplementedFiscalYearPeriod', [
              undefined,
              lastImplementedFiscalYearPeriod?.[1],
            ]);
          }}
        />
      )}
      {endYear && (
        <SearchFilterTag
          closable={true}
          label={t('last-implemented-fiscal-year-range-max-with-value', {
            value: endYear,
          })}
          onClose={() => {
            setValue('lastImplementedFiscalYearPeriod', [
              lastImplementedFiscalYearPeriod?.[0],
              undefined,
            ]);
          }}
        />
      )}
    </>
  );
};
